<template>
    <div class="bg-white border shadow dark:bg-zinc-800 dark:border-zinc-900 border-neutral-200">
        <div
            class="flex items-center w-full px-4 py-2 border min-h-28 dark:border-zinc-950 border-neutral-200"
            :class="[props.loading ? 'animate-pulse' : '']"
        >
            <div class="flex-auto">
                <div v-if="props.value" class="text-xl font-bold">
                    {{ props.value }}
                </div>
                <div v-if="props.subvalue" class="font-bold">
                    {{ props.subvalue }}
                </div>
                <div v-if="props.label">
                    {{ props.label }}

                    <small v-if="props.info" class="text-xs">
                        {{ props.info }}
                    </small>
                </div>
            </div>
            <div class="grow-0">
                <slot name="icon">
                    <icon icon="quill/sort" class="w-5 h-5"></icon>
                </slot>
            </div>
        </div>

        <div v-if="hasLeaderboard">
            <table class="w-full border-t dark:border-zinc-950 border-neutral-200">
                <thead class="bg-gray-100 dark:bg-zinc-700">
                    <tr>
                        <th class="px-4 text-left">Jméno</th>
                        <th class="px-4 text-center">Počet</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-neutral-200 dark:divide-zinc-950">
                    <tr
                        v-for="entry in props.leaderboard"
                        :key="entry.email"
                        :class="[
                            entry.id === $page.props.auth.user.id
                                ? 'bg-cyan-200 dark:bg-cyan-800 shadow-sm shadow-cyan-200 dark:shadow-cyan-600'
                                : '',
                        ]"
                    >
                        <td class="px-4">
                            {{ entry.name }}
                        </td>
                        <td class="px-4 text-center">
                            {{ entry[props.leaderboardValue] }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    value?: number | undefined;
    subvalue?: string | number;
    label?: string;
    info?: string;
    loading?: boolean;
    leaderboard?: any[];
    leaderboardValue?: string;
}

const props = withDefaults(defineProps<Props>(), {
    value: undefined,
    subvalue: undefined,
    label: '',
    info: '',
    loading: false,
    leaderboard: () => [],
    leaderboardValue: undefined,
});

const hasLeaderboard = computed(() => props.leaderboard.length > 0);
</script>
